import React, { useState, useEffect, useContext } from "react";
import useTable from "../../components/useTable";
import { Dimmer } from "../../components/spinner";
import { EditarUsuarioWeb } from "../../components/hacienda/actividadEconomica/modalEditarUsuarioWeb";
import { Mensaje } from "../../components/mensajes";
import { AuthContext } from "../../context/auth";
import axios from "axios";
import { Toasts } from "../../components/toasts";

import { SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";

const headCells = [
  {
    id: "codigo",
    label: "CODIGO",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "usuario",
    label: "USUARIO",
    width: "auto",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "opciones",
    label: "OPCIONES",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
];

function UsuarioWeb(props) {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const permiso = JSON.parse(localStorage.getItem("accacticontri"));
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [operacion, setOperacion] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [usuario, setUsuario] = useState("");
  const [tributos, setTributos] = useState([
    {
      idusuarioweb: "",
      tributo: "",
      idtributo: "",
      nombre: "",
      documento: "",
      direccion: "",
      numeroident: "",
    },
  ]);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([
    {
      id: "",
      username: "",
      password: "",
    },
  ]);

  const { user } = useContext(AuthContext);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuarioweb.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const handleCancela1 = () => {
    setMostrar1(false);
    setUsuario("");
  };
  const handleCloseMensa = () => {
    setMostrar(false);
  };
  const seleccionarRegistro = (idusuarioweb) => {
    let campos = "*";
    let nomtab = "usuarioweb";
    let nomid = "idusuarioweb";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idusuarioweb}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setUsuario(response.data);
          seleccionarTributos(idusuarioweb);
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "usuarioweb";
    let orden = "idusuarioweb";
    setActivate(true);
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };
  const seleccionarTributos = (idusuarioweb) => {
    setActivate(true);
    let endpoint =
      op.conexion + `/api/industria/mistributos?idusuarioweb=${idusuarioweb}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setTributos(response.data);
          setMostrar1(true);
          setActivate(false);
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };
  const editarUsuario = (id, per) => (event) => {
    event.preventDefault();
    if (per.toString() === "1") {
      if (id === "") {
        setOperacion(1);
        setTributos("");
        setMostrar1(true);
      } else {
        setOperacion(2);
        seleccionarRegistro(id);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje: "No posee permiso para este modulo",
        titulo: "Alerta.",
      });
    }
  };

  useEffect(() => {
    seleccionarRegistros();
    setActivate(true);
  }, []);

  const cerrar = () => {
    props.setTabla(0);
  };

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  return (
    user && (
      <div className="col-8 m-0 p-2 border rounded mx-auto mt-5">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
          <h3 className="fw-bold m-0">Gestion de Usuarios Web</h3>
          <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
            Salir <i className="fas fa-times ms-2"></i>
          </a>
        </header>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-6 col-lg-4 m-0 p-0">
            <SearchInput className='search-input ' placeholder="Buscar" onChange={handleSearch} />
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton
              icon="fa-plus m-0"
              onClick={editarUsuario("", permiso.toString().substring(0, 1))}
              disable={permiso.toString().substring(0, 1) !== "1"}
            />
          </div>
        </div>

        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={index} style={{ padding: "0" }}>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center" }}
                    >
                      {item.idusuarioweb}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center" }}
                    >
                      {item.login}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "150px" }}
                    >
                      <button
                        onClick={editarUsuario(
                          item.idusuarioweb,
                          permiso.toString().substring(1, 2)
                        )}
                        className={
                          permiso.toString().substring(1, 2) === "1"
                            ? "btn btn-sm btn-info rounded-pill"
                            : "btn btn-sm btn-secondary rounded-pill"
                        }
                      >
                        <i className="fa fa-edit"> Gestionar</i>{" "}
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>

        <Toasts
          show={toast.mostrar}
          titulo={toast.titulo}
          mensaje={toast.mensaje}
          onHideCancela={cerrarToast}
        />

        <EditarUsuarioWeb
          show={mostrar1}
          usuario={usuario}
          tributos={tributos}
          operacion={operacion}
          onHideCancela={handleCancela1}
          renderizar={seleccionarRegistros}
          onHideRenderizarTributos={seleccionarTributos}
        />
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        {<Dimmer active={activate} inverted></Dimmer>}
      </div>
    )
  );
}

export default UsuarioWeb;
